/**
 * Variante del aviso bajo la tarjeta de búsqueda del mapa.
 */
export const VARIANTE_DISCLAIMER_HOME = 'home';

/**
 * Variante del aviso dentro del detalle de un corte imprevisto.
 */
export const VARIANTE_DISCLAIMER_DETALLE = 'detalle';

/**
 * Identificador de prueba del aviso de emergencia climática.
 */
export const TEST_ID_DISCLAIMER_PEC = 'disclaimer-pec';

/**
 * Identificador de prueba del botón que abre o cierra el aviso en mobile.
 */
export const TEST_ID_TOGGLE_DISCLAIMER_PEC = 'disclaimer-pec-toggle';

/**
 * Variable CSS que publica el alto del aviso para el buscador y el mensaje flotante.
 */
export const VARIABLE_ALTO_DISCLAIMER_PEC = '--alto-disclaimer-pec';

/**
 * Separación, en píxeles, que se suma al alto medido del aviso.
 */
export const SEPARACION_DISCLAIMER_BUSCADOR = 12;

/**
 * Unidad del alto publicado en la variable CSS.
 */
export const SUFIJO_PX = 'px';

/**
 * Prefijo que Material-UI agrega al media query y que `matchMedia` no usa.
 */
export const PREFIJO_REGLA_MEDIA = '@media ';

/**
 * Evento del media query cuando cambia el ancho de la ventana.
 */
export const EVENTO_CAMBIO_MEDIA = 'change';

/**
 * Resultado de `typeof` cuando el valor es una función.
 */
export const TIPO_FUNCION = 'function';

/**
 * Valor del atributo cuando el aviso está abierto.
 */
export const VALOR_EXPANDIDO = 'true';

/**
 * Valor del atributo cuando el aviso está cerrado.
 */
export const VALOR_COLAPSADO = 'false';

/**
 * Nombre del atributo que identifica la variante en pruebas.
 */
export const ATRIBUTO_VARIANTE = 'data-variante';

/**
 * Nombre del atributo que indica si el aviso está abierto.
 */
export const ATRIBUTO_EXPANDIDO = 'data-expandido';

/**
 * Clave i18n del título del aviso.
 */
export const CLAVE_TITULO_DISCLAIMER_PEC = 'desconexion:paginas.mapaCortes.disclaimerPec.titulo';

/**
 * Clave i18n del cuerpo del aviso.
 */
export const CLAVE_DESCRIPCION_DISCLAIMER_PEC = 'desconexion:paginas.mapaCortes.disclaimerPec.descripcion';

/**
 * Clave i18n de la acción para abrir el aviso.
 */
export const CLAVE_EXPANDIR_DISCLAIMER_PEC = 'desconexion:paginas.mapaCortes.disclaimerPec.expandir';

/**
 * Clave i18n de la acción para cerrar el aviso.
 */
export const CLAVE_CONTRAER_DISCLAIMER_PEC = 'desconexion:paginas.mapaCortes.disclaimerPec.contraer';
